import React, { useEffect, useRef } from 'react'
import { useKey } from 'react-use'
import ReactDOM from 'react-dom'
import formatMessage from 'format-message'
import classnames from 'classnames'
import WarningIcon from './icons/warning'
import AlertIcon from './icons/alert'
import './GenericPopup.css'

export default function GenericPopup({
  message,
  onCancel,
  onConfirm,
  severity,
  onRender
}) {
  const cancelButton = useRef(null)
  const okButton = useRef(null)

  useKey('Escape', onCancel)

  useEffect(() => {
    if (cancelButton && cancelButton.current) {
      cancelButton.current.focus()
    } else if (okButton && okButton.current) {
      okButton.current.focus()
    }
    let timer1
    if (onRender) {
      timer1 = setTimeout(onRender, 5000)
      return () => {
        clearTimeout(timer1);
      };
    }
  }, [])

  const handleCancelKeyDown = event => {
    if (event.key === 'Tab') {
      event.preventDefault()
      if (okButton) {
        okButton.current.focus()
      }
    }
  }

  const handleOkKeyDown = event => {
    if (event.key === 'Tab') {
      event.preventDefault()
      if (cancelButton) {
        cancelButton.current.focus()
      }
    }
  }

  const classNames = classnames('GenericPopup', `GenericPopup-${severity}`)
  const domNode = document.querySelector('#App')
  const icons = {
    alert: <AlertIcon />,
    warning: <WarningIcon />
  }
  const confirm = onConfirm && (
    <button
      id="GenericPopup-confirm-button"
      key="confirmButton"
      className="inst-button GenericPopup-button GenericPopup-confirm-button"
      onClick={onConfirm}
      ref={okButton}
      aria-label={formatMessage('Ok')}
      aria-describedby="GenericModal-message"
      onKeyDown={handleOkKeyDown}
    >
      {formatMessage('Ok')}
    </button>
  )
  const cancel = onCancel && (
    <button
      id="GenericPopup-cancel-button"
      key="cancelButton"
      className="inst-button GenericPopup-button"
      onClick={onCancel}
      ref={cancelButton}
      aria-label={formatMessage('Cancel')}
      aria-describedby="GenericModal-message"
      onKeyDown={handleCancelKeyDown}
    >
      {formatMessage('Cancel')}
    </button>
  )
  const buttons = [cancel, confirm].filter(button => {
    return !!button
  })
  return ReactDOM.createPortal(
    <div>
      <div
        style={{
          position: 'fixed',
          height: '100%',
          width: '100%',
          top: '0'
        }}
      />
      <div className={classNames} tabIndex={-1}>
        {icons[severity]}
        <div style={{ padding: '5px' }}>
          <p id="GenericModal-message">{message}</p>
          {typeof onConfirm === 'function' && (
            <div style={{ display: 'flex' }}>{buttons}</div>
          )}
        </div>
      </div>
    </div>,
    domNode
  )
}
